export default __webpack_public_path__ + "icon_view_website.78e9ce17413da4b12ca0b25c3eed69fd.svg";